import React, { useState } from 'react';
import JobPostsMarketingSection from 'components/JobOpeningsPage/JobPostsMarketingSection';
import JobPostsFilters from './JobPostsFilters';
import JobCards from './JobCards';
import { SectionContainer } from './styles';

const JobPostsHeroSection = ({ background, title, description, jobCards, ...otherProps }) => {
  const [clickedJobIndex, setClickedJobIndex] = useState(-1);
  const [filteredCards, setFilteredCards] = useState(jobCards);

  return (
    <SectionContainer background={background} {...otherProps}>
      <div className="section-job-posts-hero--wrapper">
        <div className="section-job-posts-hero--container">
          <h2 className="section-job-posts-hero--title">{title}</h2>
          <p className="section-job-posts-hero--description">{description}</p>
          <div className="section-job-posts-hero--card-content">
            <JobPostsFilters
              cards={jobCards}
              setClickedJobIndex={setClickedJobIndex}
              setFilteredCards={setFilteredCards}
            />
            <JobCards
              cards={filteredCards}
              onJobClick={setClickedJobIndex}
              clickedJobIndex={clickedJobIndex}
            />
          </div>
        </div>
      </div>

      {clickedJobIndex >= 0 && filteredCards.length > 0 && (
        <JobPostsMarketingSection
          background="#FFFFFF"
          title={filteredCards[clickedJobIndex].name}
          description={filteredCards[clickedJobIndex].description}
          jobCards={filteredCards[clickedJobIndex].jobs}
        />
      )}
    </SectionContainer>
  );
};

export default JobPostsHeroSection;
